/* eslint no-undef: "off" */

import axios from 'axios'
import { ID_DATA } from '~/js/constants/data-element-ids'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import { CART_ORDER_CURTAIN_LINK } from '~/js/constants/local-storage-keys'
const CLASS_NAME_ORDER_CURTAIN_LINK = 'js-orderCurtainLink'

document.addEventListener('DOMContentLoaded', () => {
  const cartItems = FFJP.cart.items

  // オーダーカーテンのPDPに遷移する前にオプションをローカルストレージに保存する
  const elementsOrderCurtainLink = document.getElementsByClassName(
    CLASS_NAME_ORDER_CURTAIN_LINK
  )
  if (elementsOrderCurtainLink.length) {
    Array.from(elementsOrderCurtainLink).forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        const orderCurtainInfo = cartItems.find(
          (x) => x.variant_id == element.dataset.variantId
        )
        localStorage.removeItem(CART_ORDER_CURTAIN_LINK)

        const c_options =
          `default,${orderCurtainInfo.properties['_有料オプション']}`.replace(
            ' ',
            ''
          )
        const localData = {
          c_id: orderCurtainInfo.product_id,
          c_size_style: orderCurtainInfo.properties['窓のタイプ'],
          c_fork: orderCurtainInfo.properties['フックタイプ'],
          c_style: orderCurtainInfo.properties['スタイル'],
          c_open: orderCurtainInfo.properties['開き方'],
          c_options,
          c_width: orderCurtainInfo.properties['_採寸幅'],
          c_height: orderCurtainInfo.properties['_採寸丈'],
          c_style_elevation: orderCurtainInfo.properties['_調整丈'],
          c_qty: orderCurtainInfo.properties['窓数'],
        }

        localStorage.setItem(CART_ORDER_CURTAIN_LINK, JSON.stringify(localData))

        window.location.href = event.target.href
      })
    })
  }
})

// すべての見積もりを保存する
export const quoteAllItems = async (element) => {
  const elementData = document.getElementById(ID_DATA)
  if (!elementData) return

  const h = elementData.dataset.hashedCustomerId

  element.setAttribute('disabled', true)
  const customer_id = FFJP.userID
  const cartItems = FFJP.cart.items
  const mainItems = cartItems.filter(
    (cartItem) => Object.keys(cartItem.properties).length
  )

  const items = mainItems.map((item) => {
    const accessories = (
      item.properties['_有料オプション'].length
        ? item.properties['_opt_ref'].split(',')
        : []
    ).map((value) => {
      const option = value.trim().split(':')
      return {
        productId: parseFloat(option[0]),
        variantId: parseFloat(option[1]),
        handle: option[2],
        fabricName: option[2].replace('nt', '').replace('se', ''),
      }
    })
    return {
      productId: parseFloat(item.product_id),
      variantId: parseFloat(item.variant_id),
      handle: item.handle,
      manufacturer: item.vendor,
      fabricName: item.product_title,
      color: item.properties['_カラーコード'],
      windowType: item.properties['窓のタイプ'],
      hookType: item.properties['フックタイプ'],
      curtainStyle: item.properties['スタイル'],
      openingType: item.properties['開き方'],
      widthCustomerMeasured: parseFloat(item.properties['_採寸幅']),
      heightCustomerMeasured: parseFloat(item.properties['_採寸丈']),
      width: parseFloat(item.properties['仕上がり幅']),
      height: parseFloat(item.properties['仕上がり丈']),
      length: parseFloat(item.properties['_調整丈']),
      windows: parseFloat(item.properties['窓数']),
      curtains: parseFloat(item.properties['枚数']),
      accessories,
    }
  })

  try {
    await axios.post(
      `${baseUrlFrontApi}/customers/order_curtain_quotation/bulk_upsert`,
      {
        customerId: customer_id,
        h,
        items: items.map((item) => ({
          quotation: item,
        })),
      }
    )
    alert('お見積書を保存しました。')
  } catch (error) {
    console.error(error)
  }
  element.removeAttribute('disabled')
}
